import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuth";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/vacanze");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Accesso non riuscito");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-anthracite px-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-3xl p-8" data-testid="admin-login-form">
        <div className="grid place-items-center h-12 w-12 rounded-2xl bg-brand text-white mb-6"><Lock className="h-5 w-5" /></div>
        <h1 className="font-display text-3xl font-semibold text-anthracite">Area riservata</h1>
        <p className="text-sm text-anthracite/50 mt-1">Casamore Servizi Immobiliari</p>
        {error && <div className="mt-4 rounded-xl bg-red-50 text-red-600 text-sm px-4 py-3" data-testid="login-error">{error}</div>}
        <label className="block mt-5 text-xs font-semibold text-anthracite/60">Email</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full h-12 rounded-xl border border-border-subtle px-3 outline-none focus:border-brand" data-testid="login-email" />
        <label className="block mt-4 text-xs font-semibold text-anthracite/60">Password</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full h-12 rounded-xl border border-border-subtle px-3 outline-none focus:border-brand" data-testid="login-password" />
        <button type="submit" disabled={loading} className="mt-6 w-full rounded-full bg-brand text-white font-semibold py-3.5 hover:bg-brand-hover transition-colors disabled:opacity-50" data-testid="login-submit">
          {loading ? "Accesso..." : "Accedi"}
        </button>
      </form>
    </div>
  );
}
